<template>
  <section class="go-beyond-info-section row">
    <GoBeyondInfo
      v-if="enableAnimations"
      v-animation
      data-animation="fade-in-left"
      data-animation-mobile="fade-in-up"
    />
    <GoBeyondInfo v-else />
    <KeyBenefits
      v-if="enableAnimations"
      v-animation
      data-animation="fade-in-right"
      data-animation-mobile="fade-in-up"
    />
    <KeyBenefits v-else />
  </section>
</template>

<script>
import KeyBenefits from './KeyBenefits';
import GoBeyondInfo from './GoBeyondInfo';

export default {
  components: {
    KeyBenefits,
    GoBeyondInfo,
  },
  props: {
    enableAnimations: Boolean,
  },
};
</script>

<style scoped lang="scss">
.go-beyond-info-section {
  display: flex;
  align-items: center;
  padding: 40px 0;
}
</style>
